/*!
 * @oarepo/invenio-oarepo-ui-quasar v1.3.3
 * (c) Miroslav Simek, CIS UCT Prague
 * Released under the MIT License.
 */
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';
import { Component, Emit, Vue } from 'vue-property-decorator';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

var _dec, _dec2, _class, _class2;
var OARepoQuasarCollectionListItem = (_dec = Component({
  props: {
    item: Object
  },
  components: {},
  name: 'oarepo-quasar-collection-list-item'
}), _dec2 = Emit('selected'), _dec(_class = (_class2 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoQuasarCollectionListItem, _Vue);

  function OARepoQuasarCollectionListItem() {
    _classCallCheck(this, OARepoQuasarCollectionListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(OARepoQuasarCollectionListItem).apply(this, arguments));
  }

  _createClass(OARepoQuasarCollectionListItem, [{
    key: "selected",
    value: function selected() {
      return this.item;
    }
  }]);

  return OARepoQuasarCollectionListItem;
}(Vue), (_applyDecoratedDescriptor(_class2.prototype, "selected", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "selected"), _class2.prototype)), _class2)) || _class);

/* script */
var __vue_script__ = OARepoQuasarCollectionListItem;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('q-item', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    attrs: {
      "clickable": ""
    },
    on: {
      "click": _vm.selected
    }
  }, [_vm._t("list-item", [_vm.item.metadata ? _c('q-item-section', {
    staticClass: "justify-start-important",
    attrs: {
      "avatar": ""
    }
  }, [_c('q-avatar', {
    attrs: {
      "square": ""
    }
  }, [_vm._t("list-item-avatar", [_c('img', {
    attrs: {
      "src": "statics/boy-avatar.png"
    }
  })], {
    "item": _vm.item
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('q-item-section', [_vm._t("list-item-main", [_vm._t("list-item-main-title-block", [_c('div', {
    staticClass: "document_title"
  }, [_vm._t("list-item-main-before-title", null, {
    "item": _vm.item
  }), _vm._v(" "), _vm._t("list-item-main-title", [_c('span', [_vm._v(_vm._s(_vm.item.metadata.title))])], {
    "item": _vm.item
  })], 2)], {
    "item": _vm.item
  }), _vm._v(" "), _vm._t("list-item-main-subtitle-block", [_c('div', {
    staticClass: "document_subtitle"
  }, [_vm._t("list-item-main-before-subtitle", null, {
    "item": _vm.item
  }), _vm._v(" "), _vm._t("list-item-main-subtitle", null, {
    "item": _vm.item
  })], 2)], {
    "item": _vm.item
  }), _vm._v(" "), _vm._t("list-item-main-author-block", [_c('div', {
    staticClass: "document_author"
  }, [_vm._t("list-item-main-before-author", null, {
    "item": _vm.item
  }), _vm._v(" "), _vm._t("list-item-main-author", [_vm._v("\n                             \n                            "), _c('span', [_vm._v(_vm._s(_vm.item.metadata.creator))]), _vm._v(" "), _vm.item.metadata.available ? _c('span', [_vm._v("\n                                                ●\n                                                " + _vm._s(_vm.$d(new Date(_vm.item.metadata.available))) + "\n                                            ")]) : _vm._e()], {
    "item": _vm.item
  })], 2)], {
    "item": _vm.item
  })], {
    "item": _vm.item
  })], 2)], {
    "item": _vm.item
  })], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = "data-v-0b42d098";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var OARepoQuasarCollectionItem = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

export { OARepoQuasarCollectionItem as O, _inherits as _, _createClass as a, _classCallCheck as b, _possibleConstructorReturn as c, _getPrototypeOf as d, _applyDecoratedDescriptor as e, _typeof as f };
